import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy
} from '@angular/core';
import { arc } from 'd3-shape';

// import { trimLabel } from '../common/trim-label.helper';

@Component({
    selector: 'g[ngx-charts-pie-label-custom]',
    template: `
      <title>{{label}}</title>
      <svg:g
        [attr.transform]="attrTransform"
        [style.transform]="styleTransform"
        [style.transition]="textTransition">
        <svg:g *ngIf="data.killer && !labelShow">
            <svg:text
                class="pie-label"
                [class.animation]="animations"
                [class.red-shadow]="textshadow"
                dy=".35em"
                style="stroke:#ff5454;stroke-width:0.6em;stroke-opacity:0.3;"
                [style.textAnchor]="textAnchor()"
                [style.shapeRendering]="'crispEdges'">
                
                <tspan x="0" [attr.dy]="'0'" [matTooltip]="label">{{splitLines(label, (labelShow?45:20))}}</tspan>
                 
            </svg:text>
        </svg:g>
        <svg:g *ngIf="data.killer && labelShow">
            <svg:text
                class="pie-label"
                [class.animation]="animations"
                [class.red-shadow]="textshadow"
                dy=".35em"
                style="stroke:#ff5454;stroke-width:0.6em;stroke-opacity:0.3;"
                [style.textAnchor]="textAnchor()"
                [style.shapeRendering]="'crispEdges'">
                <tspan *ngFor="let line of splitLines(label, 30); let i = index" x="0" [attr.dy]="i === 0 ? '0' : '1.2em'">{{line}}</tspan>
            </svg:text>
        </svg:g>
        <svg:text *ngIf="!labelShow || true"
          class="pie-label"
          [class.animation]="animations"
          [class.red-shadow]="textshadow"
          dy=".35em"
          [style.textAnchor]="textAnchor()"
          [style.shapeRendering]="'crispEdges'">
          <tspan x="0" [attr.dy]="'0'" [matTooltip]="label">{{splitLines(label, 75)}}</tspan>
        </svg:text>
        <svg:text *ngIf="false && labelShow"
          class="pie-label"
          [class.animation]="animations"
          [class.red-shadow]="textshadow"
          dy=".35em"
          [style.textAnchor]="textAnchor()"
          [style.shapeRendering]="'crispEdges'">
          <tspan *ngFor="let line of splitLines(label, 75); let i = index" x="0" [attr.dy]="i === 0 ? '0' : '1.2em'"  [matTooltip]="line">{{line}}</tspan>
        </svg:text>
      </svg:g>
      <svg:path
        [attr.d]="line"
        [attr.stroke]="color"
        fill="none"
        class="pie-label-line line"
        [class.animation]="animations">
      </svg:path>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PieLabelCustomComponent implements OnChanges {

    @Input() data;
    @Input() radius;
    @Input() label;
    @Input() color;
    @Input() max;
    @Input() value;
    @Input() labelShow: boolean = false;
    @Input() explodeSlices;
    @Input() animations: boolean = true;
    @Input() textshadow: boolean = false;

    trimLabel: (label: string, max?: number) => string;
    line: string;
    labelLines: any[] = [];

    private readonly isIE = /(edge|msie|trident)/i.test(navigator.userAgent);

    constructor() {
        // this.trimLabel = trimLabel;
        // this.labelLines = this.splitLines(this.label, 100);
    }

    breakLabel(label) {
        return label + '<br />';
    }

    splitLines(text:any, maxTextWidth:any) {
        // console.log(text.toString().length,"splitLines", text, maxTextWidth)
        let length = text.toString().length;
        let allLines;
        if(length > maxTextWidth){
            allLines = text.slice(0,maxTextWidth) + '...';
        }else{
            allLines = text;
        }
        console.log(allLines);
        // if (!text) return [];
        // const words = text.split(' ');
        // const lastWord = words[words.length - 1];
        // let lineWidth = 0;
        // let thisLine = '';
        // const allLines:any = new Array();

        // for (let i = 0; i < words.length; i++) {
        //     const word = words[i];
        //     thisLine = thisLine.concat(word + ' ');
        //     lineWidth = thisLine.length;
        //     if (word !== lastWord) {
        //         const nextWord = words[i + 1];
        //         if (lineWidth + nextWord.length >= maxTextWidth) {
        //             addToAllLines(thisLine);
        //         } else if (word === '~') {
        //             addToAllLines(' ');
        //         } else if (nextWord === '~') {
        //             addToAllLines(thisLine);
        //         }
        //     } else {
        //         addToAllLines(thisLine);
        //     }
        // }
        
        // function addToAllLines(text) {
        //     allLines.push(text);
        //     thisLine = '';
        //     lineWidth = 0;
        // }
        return allLines;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }

    // update(): void {
    //     let startRadius = this.radius;
    //     if (this.explodeSlices) {
    //         startRadius = this.radius * this.value / this.max;
    //     }

    //     const innerArc = arc()
    //         .innerRadius(startRadius)
    //         .outerRadius(startRadius);

    //     // Calculate innerPos then scale outer position to match label position
    //     const innerPos = innerArc.centroid(this.data);

    //     let scale = this.data.pos[1] / innerPos[1];
    //     if (this.data.pos[1] === 0 || innerPos[1] === 0) {
    //         scale = 1;
    //     }
    //     const outerPos = [scale * innerPos[0], scale * innerPos[1]];

    //     this.line = `M${innerPos}L${outerPos}L${this.data.pos}`;
    //     console.log(this.line, 'line', innerPos, 'innerPos', outerPos, 'outerPos', this.data.pos, 'this.data.pos');
    // }
    update(): void {
        let startRadius = this.radius;
        if (this.explodeSlices) {
            startRadius = this.radius * this.value / this.max;
        }

        const innerArc = arc()
            .innerRadius(startRadius)
            .outerRadius(startRadius);

        const innerPos = innerArc.centroid(this.data);

        let scale = this.data.pos[1] / innerPos[1];
        if (this.data.pos[1] === 0 || innerPos[1] === 0) {
            scale = 1;
        }

        const outerPos = [scale * innerPos[0], scale * innerPos[1]];

        // if left vertical line - removed outerPos from this.line to shorten the line width.@@54154 @@07-10-2025@@
        const isLeftStraight = Math.abs(innerPos[1]) < 0.001 && innerPos[0] < 0;
        if (isLeftStraight) {
            this.line = `M${innerPos}L${this.data.pos}`;
        } else {
            this.line = `M${innerPos}L${outerPos}L${this.data.pos}`;
        }
    }


    get textX(): number {
        return this.data.pos[0];
    }

    get textY(): number {
        return this.data.pos[1];
    }

    get styleTransform(): any {
        return this.isIE ? null : `translate3d(${this.textX}px,${this.textY + 7}px, 0)`;
    }

    get attrTransform(): any {
        return !this.isIE ? null : `translate(${this.textX},${this.textY})`;
    }

    get textTransition(): any {
        return (this.isIE || !this.animations) ? null : 'transform 0.75s';
    }

    textAnchor(): any {
        return this.midAngle(this.data) <= Math.PI ? 'start' : 'end';
    }

    midAngle(d): number {
        return d.startAngle + (d.endAngle - d.startAngle) / 2;
    }

}